/* The second row takes any slack, so a tall left column never opens a gap between the side column's cards. */
.main { display: grid; gap: 28px; align-items: start; grid-template-columns: minmax(0, 1fr) 440px; grid-template-rows: auto 1fr; grid-template-areas: "thresholds sideTop" "thresholds side"; }
.sportArea { display: contents; }
.sportArea > .recalcLive { grid-area: banner; }
/* The run and other banner spans both columns, and only takes a row while it shows: an empty row would still add a gap. */
.main:has(> .sportArea > .recalcLive:not(:empty)) { grid-template-rows: auto auto 1fr; grid-template-areas: "banner banner" "thresholds sideTop" "thresholds side"; }
.side { grid-area: side; display: flex; flex-direction: column; gap: 28px; }
.sideTop { grid-area: sideTop; display: flex; flex-direction: column; gap: 28px; }
.thresholds { grid-area: thresholds; min-width: 0; display: flex; flex-direction: column; gap: 28px; }
.ftpPanel { min-width: 0; background: var(--paper); border: var(--border-panel); box-shadow: var(--shadow-panel); }
.ftpHead { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 22px 24px; background: var(--ink); }
.ftpTitle { margin: 0; font-family: var(--font-cond); font-size: 32px; font-weight: 800; letter-spacing: -1px; color: var(--paper); }
.ftpSub { margin: 4px 0 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--pink); }
/* Two classes: .btn's ink border loads after this module and would vanish against the ink header. */
.ftpHead > .addFtp { border-color: var(--paper); }
/* Out of flow while empty, so it adds no gap to its column. Not display: contents, which drops the role in older browsers. */
.recalcLive:empty { position: absolute; }
.recalc { display: flex; align-items: center; gap: 12px; }
.recalc svg { flex: none; }
.stepChart { height: 192px; display: flex; align-items: flex-end; gap: 4px; padding: 24px 24px 8px; border-bottom: var(--border-hair); overflow-x: auto; }
.segment { flex: 1; min-width: 72px; display: flex; flex-direction: column; justify-content: flex-end; gap: 6px; height: 100%; }
.segmentValue { font-family: var(--font-cond); font-size: 24px; font-weight: 900; line-height: 1.1; }
.segmentBar { display: block; background: var(--pink); border: 1.5px solid var(--ink); }
.segmentDate { height: 18px; padding-top: 4px; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.8px; color: var(--text-secondary); white-space: nowrap; }
.segment[data-current='true'] .segmentValue { color: var(--hot); }
.segment[data-current='true'] .segmentBar { background: var(--hot); }
/* Run past entries are sport-run at 40%; the board has no token for that tint. */
.stepChart[data-sport='run'] .segmentBar { background: color-mix(in srgb, var(--sport-run) 40%, transparent); }
.stepChart[data-sport='run'] .segment[data-current='true'] .segmentBar { background: var(--sport-run); }
.stepChart[data-sport='run'] .segment[data-current='true'] .segmentValue { color: var(--sport-run); }
.stepChart[data-sport='other'] .segmentBar { background: var(--paper-2); }
.stepChart[data-sport='other'] .segment[data-current='true'] .segmentBar { background: var(--ink); }
.table th:first-child, .table td:first-child { padding-left: 24px; width: 180px; }
.table th:nth-child(3), .table td:nth-child(3) { width: 180px; }
.table th:last-child, .table td:last-child { width: 160px; padding-right: 24px; }
.table td[colspan] { padding: 12px 24px; }
.valueLine { display: inline-flex; align-items: center; }
.valueText { font-family: var(--font-cond); font-size: 26px; font-weight: 900; }
.current { margin-left: 10px; padding: 3px 7px; background: var(--green); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; }
.source { display: block; margin-top: 2px; font-size: 8px; letter-spacing: 0.8px; color: var(--text-secondary); }
.meta { display: none; }
.actions { text-align: right; }
.edit, .deleteLink { display: inline-flex; align-items: center; justify-content: center; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; }
.edit { margin-right: 10px; }
.deleteLink { color: var(--hot); }
.icon { display: none; }
.thresholdForm { display: flex; align-items: flex-end; flex-wrap: wrap; gap: 12px; padding: 16px 24px; }
.formField { display: flex; flex-direction: column; gap: 6px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; }
.formField input { padding: 10px 12px; border: var(--border-control); background: var(--paper); font-family: var(--font-sans); font-size: 15px; }
/* Two classes: .alert-hot loads after this module and would set 10px vertical padding; this keeps the old 8px. */
:global(.alert-hot).formError { width: 100%; padding-top: 8px; padding-bottom: 8px; }
.tableError { margin: 0; padding: 8px 24px; background: var(--hot-8); border-bottom: 1.5px solid var(--hot); font-size: 13px; }

/* Desktop and tablet only; two classes so it beats .page's 48px, which global.css loads after this module. */
@media (min-width: 640px) {
  .page:global(.page) { padding-bottom: 56px; }
}

@media (max-width: 1023px) {
  .main { grid-template-columns: minmax(0, 1fr); grid-template-rows: none; grid-template-areas: "thresholds" "sideTop" "side"; }
  .main:has(> .sportArea > .recalcLive:not(:empty)) { grid-template-rows: none; grid-template-areas: "banner" "thresholds" "sideTop" "side"; }
}

@media (max-width: 639px) {
  .ftpPanel { box-shadow: 4px 4px 0 var(--ink); }
  .ftpHead { align-items: flex-start; padding: 16px; }
  .ftpTitle { font-size: 28px; }
  .ftpSub { font-size: 9px; letter-spacing: 1px; line-height: 1.5; }
  .ftpHead > .addFtp { padding: 0 14px; }
  .recalc { align-items: flex-start; gap: 10px; line-height: 1.5; }
  /* Two classes: .alert-amber loads after this module and would set 1px. */
  :global(.alert-amber).recalc { letter-spacing: 0.8px; }
  .recalc svg { margin-top: 2px; }
  .stepChart { height: 184px; padding: 20px 16px 8px; }
  .segment { min-width: 80px; }

  .table tr { display: grid; grid-template-columns: minmax(0, 1fr) 44px 44px; align-items: center; column-gap: 0; padding: 10px 8px 10px 16px; border-bottom: var(--border-hair); }
  /* (0,1,2): beats .data-table td, which global.css loads after this module. */
  .table tbody td { padding: 0; border: 0; }
  .table td:first-child, .table td:last-child, .table td:nth-child(3) { width: auto; padding: 0; }
  .table td[data-cell='from'], .table td[data-cell='rides'] { display: none; }
  .table td[data-cell='value'] { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
  .valueLine { gap: 10px; }
  .current { margin-left: 0; padding: 3px 7px; }
  .meta { display: block; font-size: 10px; letter-spacing: 0.6px; color: var(--text-secondary); }
  .table td.actions { display: contents; }
  .edit, .deleteLink { width: 44px; height: 44px; margin: 0; padding: 0; }
  .deleteLink { color: var(--hot); }
  .actions [role='group'] { grid-column: 1 / -1; margin-top: 8px; }
  .icon { display: block; }
  .table tr:has(td[colspan]) { display: block; padding: 0; }
  .table td[colspan] { display: block; padding: 0; }
  .thresholdForm { padding: 16px; }
  .formField { flex: 1 1 140px; }
  .formField input { min-height: 44px; }
  .tableError { padding: 8px 16px; }
}

.card { display: flex; flex-direction: column; align-items: flex-start; gap: 16px; padding: 24px; border: var(--border-hair); }
.card[data-tone='strong'] { border: var(--border-panel); }
.cardHead { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.cardTitle { margin: 0; font-family: var(--font-cond); font-size: 28px; font-weight: 900; }
.chip { display: inline-flex; align-items: center; gap: 6px; padding: 4px 8px; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; background: var(--paper-2); }
.chip::before { content: ''; width: 6px; height: 6px; border-radius: 50%; background: var(--ink); }
.chip[data-tone='green'] { background: var(--green); }
.chip[data-tone='hot'] { background: var(--hot); color: var(--paper); }
.kvList { width: 100%; display: flex; flex-direction: column; gap: 16px; margin: 0; }
.kv { display: flex; justify-content: space-between; gap: 12px; padding-bottom: 10px; border-bottom: var(--border-hair); }
.kvKey { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.kvValue { margin: 0; font-size: 13px; text-align: right; }
.note { margin: 0; font-size: 12px; line-height: 1.45; color: var(--text-secondary); }
.noteLink { color: var(--ink); text-decoration: underline; }
.card > :global(.btn-outline):disabled { border-color: var(--line); color: var(--text-secondary); opacity: 1; }
.passwordForm { width: 100%; display: flex; flex-direction: column; align-items: stretch; gap: 12px; }
.passwordForm :global(.btn) { align-self: flex-start; }
.danger { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; padding: 24px; background: var(--hot-8); border: 1.5px solid var(--hot); }
.dangerTitle { margin: 0; font-family: var(--font-mono); font-size: 10px; font-weight: 400; letter-spacing: 1.4px; color: var(--hot); }
.dangerBody { margin: 0; font-size: 13px; line-height: 1.45; }

.hrHistory { width: 100%; display: flex; flex-direction: column; gap: 12px; }
.hrCurrent { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.hrValueLine { display: flex; flex-direction: column; gap: 2px; margin: 0; }
.hrValue { font-family: var(--font-cond); font-size: 40px; font-weight: 900; letter-spacing: -1.2px; line-height: 1; }
.hrSince { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.hrHistory .table th:first-child, .hrHistory .table td:first-child { width: auto; padding-left: 0; }
.hrHistory .table th:nth-child(3), .hrHistory .table td:nth-child(3) { display: none; }
.hrHistory .table th:last-child, .hrHistory .table td:last-child { width: auto; padding-right: 0; }
.hrHistory .table td[colspan] { padding: 12px 0; }
.hrHistory .thresholdForm, .hrHistory .tableError { padding-left: 0; padding-right: 0; }

@media (max-width: 639px) {
  .card, .danger { padding: 20px; }
  .kvValue { min-width: 0; overflow-wrap: anywhere; }
  .card > :global(.btn), .danger > :global(.btn) { width: 100%; }
  .passwordForm :global(.btn) { align-self: stretch; }
  .passwordForm .formField { flex: none; }
  .passwordForm .formField input { min-height: 44px; }
  .hrHistory .table tr { padding-left: 0; padding-right: 0; }
}
